import { render, staticRenderFns } from "./StatDetails.vue?vue&type=template&id=47470535"
import script from "./StatDetails.vue?vue&type=script&lang=js"
export * from "./StatDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports